import HeaderContent from "./layout/components/HeaderContent";
import React from "react";
import { Show, ShowProps, useShowController } from "react-admin";
import styled from "styled-components";

interface ShowWrapperProps extends ShowProps {
  breadcrumb: {
    link: string;
    title: string;
    params?: string;
  }[];
  isDefaultTitle?: boolean;
  isFullName?: boolean;
  customFieldName?: string;
  customNameWithId?: string;
  customResource?: string;
  customName?: {
    resourceName: string;
    propertyName: string;
  };
  isHaveSchoolFilter?: boolean;
  children: React.ReactElement;
}

const StyledShow = styled(Show)({
  "& .MuiCardContent-root": {
    padding: "24px 34px",
  },
  "& > div:first-child": {
    padding: "0px 0px 20px 0px",
  },
});

const ShowWrapper: React.FC<ShowWrapperProps> = (props) => {
  const {
    breadcrumb,
    isDefaultTitle,
    isFullName,
    customFieldName,
    customNameWithId,
    customResource,
    customName,
    children,
    isHaveSchoolFilter,
    ...showProps
  } = props;
  const controllerProps = useShowController(showProps);
  const { defaultTitle, record } = controllerProps;

  let headerTitle;

  if (isDefaultTitle) {
    headerTitle = defaultTitle;
  } else if (isFullName) {
    headerTitle = `${record?.firstName} ${record?.lastName}`;
  } else if (customFieldName && record) {
    headerTitle = record[customFieldName] || record.id;
  } else if (customNameWithId) {
    headerTitle = `${customNameWithId} #${record?.id || ""}`;
  } else if (customName && record) {
    headerTitle = `${customName.resourceName} - ${
      record[customName.propertyName] ?? ""
    }`;
  } else {
    headerTitle = record?.name || "";
  }

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle={headerTitle}
        isNotHaveSchoolFilter={!isHaveSchoolFilter}
        photoUrl={record?.photoUrl}
      />

      <StyledShow {...showProps}>{children}</StyledShow>
    </>
  );
};

export default ShowWrapper;
